/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Container, Stack, TextField, Box, IconButton, FormControl, InputLabel, Select, FormHelperText, Chip } from '@material-ui/core';
import Page from '../../../Page';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Button from '@material-ui/core/Button';
import { ToastContainer } from 'react-toastify';
import MenuItem from '@material-ui/core/MenuItem';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { makeStyles } from '@material-ui/styles';
import Paper from '@material-ui/core/Paper';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import _ from 'lodash';
import { Autocomplete, Checkbox } from '@mui/material';
import CreatePDF from './CreatePdf';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import PropTypes, { func } from 'prop-types'
import TablePagination from '@mui/material/TablePagination';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { useTheme } from '@mui/material/styles'
import services from '../Service';
import { CheckBox } from '@material-ui/icons';
import ClearIcon from '@mui/icons-material/Clear';

var screenCode = "PENDINGPACKAGEDETAILSREPORT"

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell></TableCell>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired
};

export default function PendingPackageDetailsReport() {
    const navigate = useNavigate();
    const componentRef = useRef();
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const [pageProps, setPageProps] = useState({
        editingID: 0,
        isEdit: true,
        pageheadername: 'Pending Package Details Report'
    });
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('FarmerName');
    const [groupList, setGroupList] = useState([]);
    const [operationEntityList, setOperationEntityList] = useState([]);
    const [grnDetails, setGRNDetails] = useState([]);
    const [toDate, setToDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date());
    const [IsFarmerClear, setIsFarmerClear] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: 0,
        fromDate: new Date(fromDate).toISOString(),
        toDate: new Date(toDate).toISOString(),
    });
    const [farmerDa, setFarmerata] = useState({
        supplierTypeID: 1
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        operationEntityID: '',
        farmerID: '',
        toDate: '',
        fromDate: ''
    });
    const [totalValues, setTotalValues] = useState({
        totalGross: 0,
        totalDeduction: 0,
        totalNet: 0,
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const useStyles = makeStyles({
        root: {
            width: '100%',
            overflowX: 'auto'
        },
    });

    const classes = useStyles();

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            fromDate: formData.fromDate,
            toDate: formData.toDate,
        },

        validationSchema: () => {
            return Yup.object().shape({
                groupID: Yup.number().min(1, 'Please Select Group').required('Group required'),
                toDate: Yup.date().min(1).min(1, 'Please Select End date').required('End date required'),
                fromDate: Yup.date().min(1).min(1, 'Please Select Start Date').required('Start Date required')
            });
        },

        onSubmit: (values) => {
            trackPromise(SubmitForm(values));
        },
    });

    async function SubmitForm(value) {
        let model = {
            groupID: parseInt(value.groupID),
            operationEntityID: selectedOptions.map(x => x).join(',').toString(),
            fromDate: new Date(fromDate).toISOString(),
            toDate: new Date(toDate).toISOString()
        }
        let newRes = await services.GetPendingReportData(model);
        setGRNDetails(newRes);
        calculateTotalQty(newRes)
        getSelectedDropdownValuesForReport(newRes);
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    useEffect(() => {
        trackPromise(getPermissions());
        setPage(0);
    }, []);

    useEffect(() => {
        trackPromise(GetOperationEntityByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setIsFarmerClear(!IsFarmerClear)
        setGRNDetails([]);
    }, [selectedOptions]);


    useEffect(() => {
        setGRNDetails([]);
    }, [formik.values.farmerID]);

    useEffect(() => {
        setGRNDetails([]);
        setIsFarmerClear(!IsFarmerClear)
    }, [farmerDa.supplierTypeID]);

    useEffect(() => {
        setGRNDetails([]);
    }, [toDate]);

    useEffect(() => {
        setGRNDetails([]);
    }, [fromDate]);

    useEffect(() => {
        setGRNDetails([]);
        setFromDate(new Date());
        setToDate(new Date());
    }, [formik.values.farmerID, formik.values.operationEntityID]);

    useEffect(() => {
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [operationEntityList]);


    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWPENDINGPACKAGEDETAILSREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
            factoryID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
        })
        trackPromise(GetAllGroups());
    }

    async function GetAllGroups() {
        let res = await services.GetAllGroupsForDropDown();
        if (res != null) {
            setGroupList(res);
        }
    }

    async function GetOperationEntityByGroupID() {
        var res = await services.GetVCCFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
            }
            setOperationEntityList(newOptionArray);
        }
    }

    async function createFile() {
        var file = await createDataForExcel(grnDetails);
        var settings = {
            sheetName: 'Pending Package Detail Report',
            fileName: 'Pending Package Detail Report',
            writeOptions: {}
        }
        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })
        let dataA = [
            {
                sheet: 'Pending Package Detail Report',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.map(x => {
                var vr = {
                    'Fresh Collection Center': x.freshCollectionCenter == null ? '-' : x.freshCollectionCenter,
                    'Date': x.fromDate == null ? '-' : new Date(x.fromDate).toLocaleDateString(),
                    'Supplier Code': x.supplierCode == null ? '-' : x.supplierCode,
                    'Supplier Name': x.supplierName == null ? '-' : x.supplierName,
                    'SKU Name': x.skuName == null ? '-' : x.skuName,
                    'SKU Code': x.skuCode == null ? '-' : x.skuCode,
                    'Gross Amount': x.grossAmount == null ? '-' : parseFloat(x.grossAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Deduction': x.deduction == null ? '-' : parseFloat(x.deduction).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    'Net Amount': x.netAmount == null ? '-' : parseFloat(x.netAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                }
                res.push(vr);
            });

            var vr = {
                'Fresh Collection Center': 'Total',
                'Gross Amount': totalValues.totalGross == null ? '-' : parseFloat(totalValues.totalGross).toFixed(2),
                'Deduction': totalValues.totalDeduction == null ? '-' : parseFloat(totalValues.totalDeduction).toFixed(2),
                'Net Amount': totalValues.totalNet == null ? '-' : parseFloat(totalValues.totalNet).toFixed(2)
            }
            res.push(vr);
            res.push({});
            res.push({});
        }
        return res;
    }

    async function clearAll() {
        setIsFarmerClear(!IsFarmerClear)
        setFormData({
            ...formData,
            farmerID: 0,
        })
        setGRNDetails([]);
        setFromDate(new Date());
        setToDate(new Date());
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        setSelectedOptions([factoryValue]);
    }

    function calculateTotalQty(grnDetails) {
        const totalGross = grnDetails.reduce((accumulator, current) => accumulator + current.grossAmount, 0);
        const totalDeduction = grnDetails.reduce((accumulator, current) => accumulator + current.deduction, 0);
        const totalNet = grnDetails.reduce((accumulator, current) => accumulator + current.netAmount, 0);
        setTotalValues({
            ...totalValues,
            totalGross: totalGross,
            totalDeduction: totalDeduction,
            totalNet: totalNet,
        })
    };

    const handleSelectChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedOptions(selectedOptions.length === operationEntityList.length ? [] : operationEntityList.map((option) => option.value));
        } else {
            setSelectedOptions(value);
        }
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
    };

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return 'Select Options'; 
        } else if (selected.length === 1) {
            const option = operationEntityList.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : ''; 
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = operationEntityList.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null; 
                } else {
                    const option = operationEntityList.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null; 
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    function getSelectedDropdownValuesForReport(data) {
        const facName = [];
        selectedOptions.forEach(x => {
            const fildered = factory.find(y => x === y.value).label
            facName.push(fildered)
        });
        let groups = group.find(x => x.groupID == formik.values.groupID)
        setSelectedSearchValues((prevState) => ({
            ...prevState,
            groupName: groups.groupName,
            factoryName: facName.length == 0 ? 'All Fresh Collection Centers' : facName.join(', '),
            date: new Date(fromDatevalue).toLocaleDateString()
        }));
    }

    return (
        <>
            <LoadingComponent />
            <Page title="Pending Package Details Report | FAPS">
                <Container>
                    <CommonPageHeader pageName={pageProps.pageheadername} leftButtonHidden={true} />
                    <FormikProvider value={formik}>
                        <ToastContainer position="bottom-right" pauseOnHover />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0} >Select Group</MenuItem>
                                        {groupList.map((option) => (
                                            <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center "
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                            renderValue={(selected) => renderSelectedValue(selected)}
                                            sx={{
                                                height: '40px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                '& .MuiOutlinedInput-input': {
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                }
                                            }}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedOptions.length === operationEntityList.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {operationEntityList.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {selectedOptions.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>
                                        )}
                                    </FormControl>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            size="small"
                                            label="From Date *"
                                            openTo="day"
                                            type="date"
                                            value={fromDate}
                                            onChange={(newValue) => {
                                                setFromDate(newValue);
                                            }}
                                            maxDate={new Date()}
                                            renderInput={(params) =>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                />}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            size="small"
                                            label="To Date *"
                                            openTo="day"
                                            type="date"
                                            value={toDate}
                                            onChange={(newValue) => {
                                                setToDate(newValue);
                                            }}
                                            maxDate={new Date()}
                                            renderInput={(params) =>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    {...params}
                                                />}
                                        />
                                    </LocalizationProvider>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <Button 
                                            type="button" 
                                            variant="outlined" 
                                            color="error"
                                            onClick={() => clearAll()}
                                            sx={{ height: '40px', minWidth: '100px' }}
                                        >
                                            Clear
                                        </Button>
                                        <Button 
                                            type="submit" 
                                            color="secondary" 
                                            variant="outlined"
                                            sx={{ height: '40px', minWidth: '100px' }}
                                        >
                                            Search
                                        </Button>
                                    </Stack>
                                </Stack>
                                <br />
                                <>
                                    {grnDetails.length != 0 ? (
                                        <>
                                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                                <Card style={{ justifycontent: 'center', width: '100rem' }}>
                                                    <Paper className={classes.paper}>
                                                        <TableContainer>
                                                            <Table
                                                                size='small'
                                                                className={classes.table}
                                                                aria-labelledby="tableTitle"
                                                                aria-label="enhanced table"
                                                            >
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell align="left">Fresh Collection Center</TableCell>
                                                                        <TableCell align="left">Date</TableCell>
                                                                        <TableCell align="left">Supplier Code</TableCell>
                                                                        <TableCell align="left">Supplier Name</TableCell>
                                                                        <TableCell align="left">SKU Name</TableCell>
                                                                        <TableCell align="left">SKU Code</TableCell>
                                                                        <TableCell align="right">Gross Amount</TableCell>
                                                                        <TableCell align="right">Deduction</TableCell>
                                                                        <TableCell align="right">Net Amount</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {stableSort(grnDetails, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                        .map((row, index) => {
                                                                            const labelId = `enhanced-table-checkbox-${index}`;
                                                                            return (
                                                                                <TableRow>
                                                                                    <TableCell align="left">{row.freshCollectionCenter == null ? '-' : row.freshCollectionCenter}</TableCell>
                                                                                    <TableCell align="left">{row.fromDate == null ? '-' : new Date(row.fromDate).toLocaleDateString()}</TableCell>
                                                                                    <TableCell align="left">{row.supplierCode == null ? '-' : row.supplierCode}</TableCell>
                                                                                    <TableCell align="left">{row.supplierName == null ? '-' : row.supplierName}</TableCell>
                                                                                    <TableCell align="left">{row.skuName == null ? '-' : row.skuName}</TableCell>
                                                                                    <TableCell align="left">{row.skuCode == null ? '-' : row.skuCode}</TableCell>
                                                                                    <TableCell align="right">{row.grossAmount == null ? '-' : parseFloat(row.grossAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                                    <TableCell align="right">{row.deduction == null ? '-' : parseFloat(row.deduction).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                                    <TableCell align="right">{row.netAmount == null ? '-' : parseFloat(row.netAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                                </TableRow>
                                                                            );
                                                                        })}
                                                                </TableBody>
                                                                <TableRow>
                                                                    <TableCell align="left" colSpan={6} style={{ fontWeight: "bold" }}>Total</TableCell>
                                                                    <TableCell align="right" style={{ fontWeight: "bold" }}>{totalValues.totalGross == null ? '-' : parseFloat(totalValues.totalGross).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell align="right" style={{ fontWeight: "bold" }}>{totalValues.totalDeduction == null ? '-' : parseFloat(totalValues.totalDeduction).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell align="right" style={{ fontWeight: "bold" }}>{totalValues.totalNet == null ? '-' : parseFloat(totalValues.totalNet).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                                                                    <TableCell></TableCell>
                                                                </TableRow>
                                                            </Table>
                                                        </TableContainer>
                                                        <TablePagination
                                                            rowsPerPageOptions={[5, 10, 25]}
                                                            component="div"
                                                            count={grnDetails.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onPageChange={handleChangePage}
                                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                                        />
                                                    </Paper>
                                                </Card>
                                            </Stack>
                                        </>
                                    ) : null}
                                </>
                            </Stack>
                        </Form>
                    </FormikProvider>
                    {grnDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorRecord}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Pending Package Detail Report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    grnList={grnDetails}
                                    searchData={selectedSearchValues}
                                    totalValues={totalValues}
                                    fromDate={fromDate}
                                    toDate={toDate}
                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}